/**
 * @Author wutao
 * @description 线下培训班级新增编辑页面
 * @Date 2020/2/21
 */
import React, {useState} from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Album, Item} from './components'

let {WizContainer, WizOssUpload, modelUtils} = framework_tool;
let {
  WizCard,
  WizSelect,
  WizRow,
  WizCol,
  WizModal,
  WizButton,
  WizSpin,
} = component_tool;
let {Session} = utils_tool;

class ClassAlbum extends WizContainer {

  componentName = 'ClassAlbum';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.record) {
      initialValue = history.location.record;
      Session.set('classAlbumManager', initialValue)
    } else {
      initialValue = Session.get('classAlbumManager') || {};
    }
    this.state = {};
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    this._init();
  }

  _init() {
    let {id} = this.initialValue
    this.doAction({
      path: 'classAlbum/list',
      payload: {
        key: 'classAlbumList',
        apiParams: {
          classInfoId: id
        }
      },
      autoInit: true,
    })
  }

  propsAndStateOnChange = {
    classAlbumList: this._classAlbumList.bind(this),
    classAlbumSave: this._classAlbumSave.bind(this),
  };

  _classAlbumList(nextProps, nextState) {
    let {classAlbumList = {}} = nextProps;
    let {success, msg, data} = classAlbumList
    if (success) {
      nextState.list = data;
    } else {
      wizNotice.error(msg || "获取数据,请稍后尝试");
    }
    return true
  }


  _classAlbumSave(nextProps, nextState) {
    let {classAlbumSave} = nextProps;
    let {success, msg} = classAlbumSave
    if (success) {
      wizNotice.success(msg || '操作成功')
      this._init();
    } else {
      wizNotice.error(msg || "操作失败,请稍后尝试");
    }
    return true
  }


  _render() {
    const {list} = this.state
    const {classAlbumLoading} = this.props;
    const {id, name, startDate, endDate} = this.initialValue;

    const _onChange = (file, type) => {
      let path, fileIds;
      if (type === 'add') {
        path = 'classAlbum/add';
        fileIds = file.filter(item => item.status === 'done').map(item => item.fileId).filter(item => !!item);
        if (file.length !== fileIds.length) {
          console.log('等待上传完毕')
          return;
        }
      } else if (type === 'remove') {
        path = 'classAlbum/del';
        fileIds = file;
      }

      if (path && id && fileIds?.length) {
        this.doAction({
          path: path,
          payload: {
            key: 'classAlbumSave',
            apiParams: {
              classInfoId: id,
              fileIds,
            }
          },
        })
      }
    }

    return (
      <WizSpin tip={'加载中'} spinning={classAlbumLoading}
               bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
        <WizCard title={'班级概况'}>
          <WizRow>
            <WizCol span={12}>
              班级名称: {name}
            </WizCol>
            <WizCol span={12}>
              班级时间: {startDate} {endDate}
            </WizCol>
          </WizRow>
        </WizCard>

        <WizCard title={'相册内容'}>
          <Album key={new Date().getTime()} fileInfoList={list} onChange={_onChange}/>
        </WizCard>
      </WizSpin>
    )
  }
}



const mapStateToProps = (state, ownProps) => {
  const {classAlbum} = state;
  const classAlbumList = modelUtils.getModelEntity(classAlbum, "classAlbumList");
  const classAlbumSave = modelUtils.getModelEntity(classAlbum, 'classAlbumSave');
  const load = modelUtils.getLoadingState(state, ['classAlbum']);
  return {
    classAlbumList,
    classAlbumSave,
    ...load
  }
};

export default connect(mapStateToProps)(ClassAlbum);
